// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CVNEo {\n    background-color: rgba(163, 189, 255, 0.15);\n    border-radius: 4px;\n    margin: var(--m) 0;\n  }\n  .X9w-y {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px;\n  }\n  .iEMFZ {\n      justify-content: end;\n      padding-bottom: 0;\n    }\n  .p2lv8 {\n    color: var(--text-heading);\n    font-weight: 600;\n  }\n  .J3Tpo {\n    padding: var(--s);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"RemovableFilterCard_cardContainer": "CVNEo",
	"RemovableFilterCard_cardContainerHeader": "X9w-y",
	"RemovableFilterCard_cardContainerHeader__iconOnly": "iEMFZ",
	"RemovableFilterCard_title": "p2lv8",
	"RemovableFilterCard_itemContainer": "J3Tpo"
};
export default ___CSS_LOADER_EXPORT___;
